import {Component, OnDestroy, Input, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FactureService } from '../../../@core/data/rest/facture/facture-service';
import { Facture } from '../../../@core/data/model/facture';


import { Partenaire } from '../../../@core/data/model/partenaire';

import { NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { SmartTableService } from '../../../@core/data/smart-table.service';
import { SharedMethods } from '../../../util/sharedMethods-service';
import { SettingService } from '../../../@core/data/rest/setting-service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LocalDataSource } from 'ng2-smart-table';
import { AuthService } from '../../../auth/auth.service';


@Component({
  selector: 'ngx-listing-modal-facture',
  styleUrls: ['./listing.modal.component.scss'],
  templateUrl: './listing.modal.component.html',
})
export class ListingFormModalComponent implements OnDestroy, OnInit {

  private alive = true;

  @Input() partenaire: Partenaire;

  @Input() typeOp: string;
  @Input() closeOnSelect: boolean;
  @Input() to: string;
  @Input() from: string;

  data: Facture[];

  typePartner: string;

  settings: any;

  labelReste: string;

  source: LocalDataSource = new LocalDataSource();

  labelPartner = '';


  labelOperation = '';

  printEtat: Facture[];

  totaux = {
    totalmontant: 0,
    totalVersements: 0,
    totalReste: 0,
  };

  printFrom = '';
  printTo = '';



  constructor(
    private service: SmartTableService,
    public factureService: FactureService,
    public route: ActivatedRoute,
    public sharedMethods: SharedMethods,
    public settingService: SettingService,
    public activeModal: NgbActiveModal,
    public authService: AuthService,
    public deviceService: DeviceDetectorService) {

      this.printEtat = [];


    // reperation de la facture à partir lde son id envoyé dans la route
    /* for ( let i = 0; i < this.factureService.getLocalFacture(this.route.snapshot.params['id']).length; i++) {

      if (this.factureService.getLocalFacture(this.route.snapshot.params['type'])[i].id.toString() === this.route.snapshot.params['id'] ) {
        this.facture = this.factureService.getLocalFacture(this.route.snapshot.params['type'])[i];
      }
      // tslint:disable-next-line:no-console
      // console.log(this.factureService.factures[i].id);
    } */

  }


  ngOnInit() {

    this.authService.logoutEvent.subscribe(() => {

      this.close();

    });


    // this.typeOp = 'vente';

    if (this.typeOp === 'vente') {
      this.typePartner = 'client';
      this.labelPartner = 'Client';
      this.labelReste = 'Créance';
      this.labelOperation = 'Vente';
    }

    if (this.typeOp === 'achat') {
      this.typePartner = 'fournisseur';
      this.labelPartner = 'Fournisseur';
      this.labelReste = 'Dette';
      this.labelOperation = 'Achat';
    }

    this.settings = {
      actions: {
        columnTitle: '',
        position: 'left',
        edit: false,
        add: false,
        delete: false,
      },
      add: {
        addButtonContent: '<i class="nb-plus"></i>',
        createButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmCreate: true,
      },
      edit: {
        editButtonContent: '<i class="nb-edit"></i>',
        saveButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmSave: true,
      },
      delete: {
        deleteButtonContent: '<i class="nb-trash"></i>',
        confirmDelete: true,
      },
      columns: {
        /* linkprint: {
          title: '',
          editable: false,
          addable: false,
          filter: false,
          type: 'custom',
          renderComponent: PrintlinkRenderComponent, // ne pas oublier de déclarer dans le module et d'ajouter dans l'entré entryComponents
        }, */
        /* id: {
          title: 'ID',
          type: 'text',
          editable: false,
          addable: false,
          filter: true,
          width: '0px',
          class: 'coloumClass',
        }, */
        refgene: {
          title: 'Numéro ',
          type: 'text',
        },
        /*   nomPartenaire: {
          title: this.labelPartner,
          type: 'text',
        }, */
        montant: {
          title: 'Net',
          type: 'text',
          filter: false,
        },
        montantReglement: {
          title: 'Règlements',
          type: 'text',
          filter: false,
        },
        reste: {
          title: this.labelReste,
          type: 'text',
          filter: false,
        },
        formatDatefac: {
          title: 'Date',
          type: 'text',
        },
        formatDateEcheance: {
          title: 'Echéance',
          type: 'html',
        },
        /* statusPaiement: {
          title: 'Paiement',
          type: 'html',
          class: 'red',
        }, */
        /* montantSansLesRetours: {
          title: 'Montant',
          type: 'text',
        },
        montantRetour: {
          title: 'Retours',
          type: 'text',
        }, */
       /*  statusLivraison: {
          title: 'Livraison',
          type: 'html',
          class: 'red',
        }, */
      },
      mode: 'external',
      noDataMessage: 'Aucune facture trouvée',
      pager: {
        display: false, // pour gerer la pagination
        perPage: 10,
      },
    };

    // on vide  dabord la source
    // this.source.load([]);
    this.source.empty();

    /* if (this.factureService.getLocalFacture(this.typeOp) === undefined) {
      this.factures();
      // this.source.setSort([{ field: 'id', direction: 'desc' }]);
    }else {
      this.source.load( this.factureLite(this.factureService.getLocalFacture(this.typeOp)) );
      // this.source.setSort([{ field: 'id', direction: 'desc' }]);
      this.factures();
    } */

    this.factures();

    /* this.intervalId = setInterval(() => {
      this.dialogIsNotShow = false;
      this.factures();
      // alert(this.intervalId);

    }, 15000); */

    // on capture le changement de source (filtre, tri, chargement) du smart table
    this.source.onChanged().subscribe( (change) => {

      this.source.getFilteredAndSorted().then( factures => {

        this.printFrom = this.settingService.formatDate(this.from);
        this.printTo = this.settingService.formatDate(this.to);

        // this.printEtat = plainToClass(Facture, factures);
        this.printEtat = factures;

        // this.printProduct = plainToClass(Produit, produits);
        // const lignesTotal = plainToClass(Facture, factures);
        const lignesTotal = factures;

        this.totaux = {
          totalmontant: 0,
          totalVersements: 0,
          totalReste: 0,
        };


        for ( let i = 0; i < lignesTotal.length; i++) {


          this.totaux.totalmontant += lignesTotal[i].montant;
          this.totaux.totalVersements += lignesTotal[i].montantReglement;
          // if (lignesTotal[i].reste > 0) // car le reste peut être négatif dans le cas ou les versements sont supérieur au montant de la facture
          this.totaux.totalReste += lignesTotal[i].reste;


        }
        // tslint:disable-next-line:no-console
        // console.log(produits);

      });

    });



  }



  factures() {

    let patner = '';

    if (this.partenaire !== undefined)
    patner = this.partenaire.id.toString();

    if ( this.to === undefined )
    this.to = '';

    if ( this.from === undefined )
    this.from = '';

    this.factureService.getFactures(this.to, this.from, this.typeOp, patner, 'unpaid', 'validate', '').then( factures => {

        // this.source.load(factures);
        this.data = factures;
        this.source.load( this.factureLite(this.factureService.getLocalFacture(this.typeOp)) );
        this.source.setFilter(null);
        this.source.setSort([{ field: 'id', direction: 'desc' }]);

    });


  }

  factureLite(factures: Facture[]): any {

    let lite: any;
    lite = [];
    for ( let i = 0; i < factures.length; i++) {

        lite.push(this.getLiteFacture(factures[i]));

    }
    return lite;

  }

  onSelectRow(event) {

    if (this.closeOnSelect) {

      let facture: Facture;

      for ( let i = 0; i < this.data.length; i++) {

        if (this.data[i].id === event.data.id ) {
          facture = this.data[i];
        }

      }

      // tslint:disable-next-line:no-console
      // console.log(facture);
      this.activeModal.dismiss(facture);

    }



  }

  getLiteFacture(facture: Facture): any {

    const litefacture = {
      link: facture.link,
      linkprint: facture.linkprint,
      id: facture.id,
      refgene: facture.refgene,
      nomPartenaire: facture.nomPartenaire,
      formatDatefac: facture.formatDatefac,
      montantSansLesRetours: facture.montantSansLesRetours,
      montantRetour: facture.montantRetour,
      montant: facture.montant,
      montantReglement: facture.montantReglement,
      reste: facture.reste,
      statusPaiement: facture.statusPaiement,
      statusLivraison: facture.checkStatusLivraison,
      formatDateEcheance: facture.formatDateEcheance,
      validater: facture.valider,
      quantiteCommander: facture.quantiteCommande,
      quantiteLivrer: facture.quantiteLivrer,
      quantiteRetour: facture.quantiteRetour,
    };

    return litefacture;

  }

  ngOnDestroy() {

  }

  close() {
    this.activeModal.dismiss();
  }


  onDelete($event) {

  }

  onCreate() {

  }

  onSave($event) {

  }

  clickprint() {

    this.captureScreen();

    // tslint:disable-next-line:no-console
    // console.log(produits);

  }

  captureScreen() {

    const data = document.getElementById('modalContentToConvert');

    const printContents = document.getElementById('modalContentToConvert').innerHTML;
    const wLeft = window.screenLeft ? window.screenLeft : window.screenX;
    const wTop = window.screenTop ? window.screenTop : window.screenY;

    const left = wLeft + (window.innerWidth / 2) - (1000 / 2);
    const top = wTop + (window.innerHeight / 2) - (1000 / 2);

    // const popupWin = window.open('', '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=1000, height=1000, top=' + top + ', left=' + left);
    const popupWin = window.open('', '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=' + screen.width + ', height=' + screen.height + ', top=0, left=0');
    popupWin.focus();
    popupWin.document.open();
    popupWin.document.write('<html> \
                                <head> \
                                  <link rel="stylesheet" type="text/css" href="assets/style/invoice.css" /> \
                                </head> \
                                <body onload="window.opener.postMessage(\'Print Open\', \'*\'); window.print()" onunload="window.opener.postMessage(\'Print Close\', \'*\');">' + printContents + ' \
                                </body> \
                             </html>');
    popupWin.document.close();
    // popupWin.close();

    /*const doc = new jspdf();

    doc.fromHTML(data, 15, 15, {
        'width': 170,
            'elementHandlers': specialElementHandlers
    });
    doc.save('sample-file.pdf'); */

    /* html2canvas(data).then(canvas => {
      // Few necessary setting options
      const imgWidth = 210; // with d'un format A4 (21cm * 29,7cm) les dimensions sont en mm ( paramètre du constructeur new jspdf())
      const pageHeight = 297;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      const heightLeft = imgHeight;

      const contentDataURL = canvas.toDataURL('image/png');
     // new JsPDF(
          // Orientation, // l (Landscape) or p (Portrait)
          // unit, // mm, cm, in
          // format // A2, A4 etc
      // );
      const pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
      const position = 10;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
      pdf.save('MYPdf.pdf'); // Generated PDF

    }); */

}


}
